module.exports = __webpack_public_path__ + "static/img/son12_active.d4ce973e.png";